import { AxiosResponse } from "axios";
import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addAppointment = catchAsync(
  (body: {
    client_id: number;
    team_member_id: number;
    date: string;
    start_time: string;
    services_ids: number[];
    products_ids: number[];
    tips: number;
    locationId: number;
  }) => {
    return axiosInstance.post(
      "salon/" + body?.locationId + "/appointments",
      body
    );
  }
);
